import styled from 'styled-components/macro';
import {themecolors} from "../utils/themecolors";

const Main = styled(({className, children}) => (
    <div className={`${className} main-content`}>
        {children}
    </div>
))`
  width: 100%;
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  border-radius: 4px;
  @media only screen and (max-width: 780px) {
    & {
      border: none;
    }
  }
`;

export default Main;
